// extracted by mini-css-extract-plugin
export default {"home":"Profile_home__SnDFV","home2":"Profile_home2__R21Xt","main":"Profile_main__a67le"};